import { useCallback } from "react";

type Opts = {
    speed?: number;              // множитель скорости
    onlyWhenScrollable?: boolean;
};

export function useHorizontalWheelScroll(
    { speed = 1, onlyWhenScrollable = true }: Opts = {}
) {
    return useCallback((e: React.WheelEvent<HTMLElement>) => {
        const el = e.currentTarget as HTMLElement;
        if (onlyWhenScrollable && el.scrollWidth <= el.clientWidth) return;
        el.scrollLeft += e.deltaY * speed;
    }, [speed, onlyWhenScrollable]);
}
